import isStolApp from '../../../../../is-stolapp'
import addAPPMessageBox from '../add-app-message-box'
import addRegisterForm from '../add-register-form'
import consoleLogger from '../../../../../console-logger'

const savePinpollVote = () => {
  //Save pinpoll vote to localstorage
  let pinpollVotes = window.localStorage.getItem('pinpollvotes')
    ? JSON.parse(window.localStorage.getItem('pinpollvotes'))
    : []

  let newpinpollVote = window.location.href
  pinpollVotes.push(newpinpollVote)
  window.localStorage.setItem('pinpollvotes', JSON.stringify(pinpollVotes))
}

const onVote = (event) => {
  if (!event.origin.endsWith('.pinpoll.com') || !event.data || event.data.event != 'vote') {
    return
  }
  const [consoleLog] = consoleLogger('Pinpoll')
  consoleLog('onVote - event', event)
  const pinPoll = document.getElementById('pinpollParentNode')
  pinPoll.style = 'display:none'

  savePinpollVote()

  if (tp.pianoId.isUserValid()) {
    window.displayPinpoll()
    return
  }

  //Create login div
  if (isStolApp()) {
    addAPPMessageBox(pinPoll)
  } else {
    addRegisterForm(pinPoll)
  }
}

export default onVote
